import store from "../store/index";
//----------------------
// get sub-status image
//----------------------
export default function getSubStatusImage(this_sub_status) {
  //------------------
  // get all statuses
  //------------------
  const this_store = store;
  const statuses = this_store.getters["combat/getStatuses"];
  //-----------------------------
  // get matching sub-status obj
  //-----------------------------
  let obj = statuses.find((a) => a.sub_status == this_sub_status);
  return obj.image;
}
